module.exports = __webpack_public_path__ + "img/finance7.5b01bee0.png";